<h4 class="mobile-nav-title mb-2" i18n>Quotes</h4>
<div class="container-fluid mb-5">
  <div *ngIf="quoteSummary.quote.customer" class="container-fluid">
    <div class="row">
      <div class="col">
        <h5>{{quoteSummary.quote.customer.customer_BusinessName}}</h5>
        <h7>{{quoteSummary.quote.quote_Name}} #{{quoteSummary.quote.quote_ProjectNumber}}</h7>
      </div>
      <div *ngIf="!isRequesting" class="col-5" align="right">
        <a href="http://maps.google.com/?q={{quoteSummary.quote.quote_Address1}},{{quoteSummary.quote.quote_City}}%20{{quoteSummary.quote.quote_State}}%20{{quoteSummary.quote.quote_Postal}}" target="_blank" class="btn btn-bidit-navigate" i18n>Map Quote</a>
        <button type="button" (click)="materialList()" class="mb-1 ml-1 btn btn-bidit-navigate" i18n>Material List</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </div>
  <br>
  <div>
    <mat-tab-group>
      <mat-tab label="Quote Details" i18n-label>
        <div class="pt-3">
          <app-quote-details-mobile [quoteSummary]="quoteSummary" (updated)="quoteUpdated($event)"></app-quote-details-mobile>
        </div>
      </mat-tab>
      <mat-tab label="Customer Info" i18n-label>
        <div class="pt-3">
          <app-project-info-mobile projectType="quote" [quote]="quoteSummary.quote"
                                   (updated)="quoteUpdated($event)"></app-project-info-mobile>
        </div>
      </mat-tab>
      <mat-tab [label]="noteLabel">
        <div class="pt-3">
          <app-project-notes-mobile [project]="quoteSummary.quote"
                                    (updated)="quoteUpdated($event)"></app-project-notes-mobile>
        </div>
      </mat-tab>
      <mat-tab [label]="documentLabel">
        <div class="pt-3">
          <app-project-documents-mobile [project]="quoteSummary.quote"
                                        (updated)="quoteUpdated($event)"></app-project-documents-mobile>
        </div>
      </mat-tab>
      <mat-tab *ngIf="quoteSummary.quote.quoteAcknowledgements" [label]="acknowledgementLabel">
        <div class="pt-3">
          <app-acknowledgement-list-mobile [project]="quoteSummary.quote"></app-acknowledgement-list-mobile>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
